function getAllParams() {
  let href = window.location.href;
  if (href.indexOf("?") !== -1) {
    let query = href.substring(href.indexOf("?") + 1);
    let item = query.split("&");
    let obj = {};
    for (let i = 0; i < item.length; i++) {
      let arr = item[i].split("=");
      obj[arr[0]] = decodeURIComponent(arr[1]);
    }
    return obj;
  } else {
    return false
  }

}

const pm2410 = [
  {
    title: 'Required Viewing',
    activeNames: [],
    url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM2410/resources/0Required Viewing.mp4',
    hasThird: false,
    children: [{
      title: 'Required Viewing',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM2410/resources/0Required Viewing.mp4',
    }]
  },
  {
    title: 'Printing PDF',
    children: [{
      title: 'Printing from a Computer',
      children: [{
        title: 'Printing standard shipping labels',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM2410/resources/1Printing standard shipping labels.mp4',
      }, {
        title: 'Printing other PDF files',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM2410/resources/2Printing other PDF files.mp4',
      }]
    }, {
      title: 'Printing from a mobile device',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM2410/resources/3Printing from a mobile device.mp4',
    }],
    activeNames: [],
    hasThird: true
  },
  {
    title: 'Creating Personalized Labels（Print barcodes, QR codes, text, icons, and other elements.）',
    children: [{
      title: 'Editing Labels on a Computer',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM2410/resources/4Editing Labels on a Computer.mp4',
    }, {
      title: 'Editing Labels on a Mobile Device',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM2410/resources/5Editing Labels on a Mobile Device.mp4',
    }],
    activeNames: [],
    hasThird: false
  },
];

const pm2411 = [
  {
    title: 'Required Viewing',
    activeNames: [],
    url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM2411/resources/0Required Viewing.mp4',
    hasThird: false,
    children: [{
      title: 'Required Viewing',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM2411/resources/0Required Viewing.mp4',
    }]
  },
  {
    title: 'Printing PDF',
    children: [{
      title: 'Printing from a Computer',
      children: [{
        title: 'Printing standard shipping labels',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM2411/resources/1Printing standard shipping labels.mp4',
      }, {
        title: 'Printing other PDF files',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM2411/resources/2Printing other PDF files.mp4',
      }]
    }, {
      title: 'Printing from a mobile device',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM2411/resources/3Printing from a mobile device.mp4',
    }],
    activeNames: [],
    hasThird: true
  },
  {
    title: 'Creating Personalized Labels（Print barcodes, QR codes, text, icons, and other elements.）',
    children: [{
      title: 'Editing Labels on a Computer',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM2411/resources/4Editing Labels on a Computer.mp4',
    }, {
      title: 'Editing Labels on a Mobile Device',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM2411/resources/5Editing Labels on a Mobile Device.mp4',
    }],
    activeNames: [],
    hasThird: false
  },
];

const d520 = [
  {
    title: 'Must Read Before Use',
    activeNames: [],
    url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/D520/D520-video1.mp4',
    hasThird: false,
    children: [{
      title: 'Required Viewing',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/D520/D520-video1.mp4',
    }]
  },
  {
    title: 'Printing Shipping Lables',
    children: [{
      title: 'Printing from a Computer',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/D520/D520-video2.mp4',
    }, {
      title: 'Printing from a mobile device',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/D520/D520-video3.mp4',
    }],
    activeNames: [],
    hasThird: false
  },
  {
    title: 'Creating Personalized Labels（Print barcodes, QR codes, text, icons, and other elements.）',
    children: [{
      title: 'Editing Labels on a Computer',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/D520/D520-video4.mp4',
    }, {
      title: 'Editing Labels on a Mobile Device',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/D520/D520-video5.mp4',
    }],
    activeNames: [],
    hasThird: false
  },
  {
    title: 'Printing LTL/Product Lables',
    children: [{
      title: 'Printing from a Computer',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/D520/D520-video6.mp4',
    }, {
      title: 'Printing from a mobile device',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/D520/D520-video7.mp4',
    }],
    activeNames: [],
    hasThird: false
  },
];
const d450 = [
  {
    title: 'Must Read Before Use',
    activeNames: [],
    url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/D520/D520-video1.mp4',
    hasThird: false,
    children: [{
      title: 'Required Viewing',
      url: '',
    }]
  },
  {
    title: 'Printing Shipping Lables',
    children: [{
      title: 'Printing from a Computer',
      url: '',
    }, {
      title: 'Printing from a mobile device',
      url: '',
    }],
    activeNames: [],
    hasThird: false
  },
  {
    title: 'Creating Personalized Labels（Print barcodes, QR codes, text, icons, and other elements.）',
    children: [{
      title: 'Editing Labels on a Computer',
      url: '',
    }, {
      title: 'Editing Labels on a Mobile Device',
      url: '',
    }],
    activeNames: [],
    hasThird: false
  },
  {
    title: 'Printing LTL/Product Lables',
    children: [{
      title: 'Printing from a Computer',
      url: '',
    }, {
      title: 'Printing from a mobile device',
      url: '',
    }],
    activeNames: [],
    hasThird: false
  },
];
const PM344WF = [
  {
    title: 'Connect to WiFi',
    activeNames: [],
    url: '',
    hasThird: false,
    children: [{
      title: 'Connect with Computer',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM-344-WF/视频1.mp4',
    }, {
      title: 'Connect with Phone',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM-344-WF/视频2.mp4',
    }]
  },
  {
    title: 'Must-Watch for New Users',
    children: [{
      title: 'Must-Watch for New Users',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM-344-WF/视频3.mp4',
    }],
    activeNames: [],
    hasThird: false
  },
  {
    title: 'Printing Shipping Lables',
    children: [{
      title: 'Print with Computer',
      children: [{
        title: 'Print via WiFi',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM-344-WF/视频4.mp4',
      }, {
        title: 'Print via USB',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM-344-WF/视频5.mp4',
      }]
    }, {
      title: 'Print with Phone',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM-344-WF/视频6.mp4',
    }],
    activeNames: [],
    hasThird: true
  },
  {
    title: 'Creating Personalized Labels（Print barcodes, QR codes, text, icons, and other elements.）',
    children: [{
      title: 'Create with Computer',
      children: [{
        title: 'Print via WiFi',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM-344-WF/视频7.mp4',
      }, {
        title: 'Print via USB',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM-344-WF/视频8.mp4',
      }]
    }, {
      title: 'Create with phone',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM-344-WF/视频9.mp4',
    }],
    activeNames: [],
    hasThird: true
  },
];

const AM243BT = [
  {
    title: 'Must-Watch Before Use',
    activeNames: [],
    url: '',
    hasThird: false,
    children: [{
      title: 'Must-Watch Before Use',
      url: '',
    }]
  },
  {
    title: 'Printing Shipping Lables',
    children: [{
      title: 'Print with Computer',
      children: [{
        title: 'Print via Bluetooth',
        url: '',
      }, {
        title: 'Print via USB',
        url: '',
      }]
    }, {
      title: 'Print with Phone',
      url: '',
    }],
    activeNames: [],
    hasThird: true
  },
  {
    title: 'Creating Personalized Labels（Print barcodes, QR codes, text, icons, and other elements.）',
    children: [{
      title: 'Create with Computer',
      children: [{
        title: 'Print via Bluetooth',
        url: '',
      }, {
        title: 'Print via USB',
        url: '',
      }]
    }, {
      title: 'Create with phone',
      url: '',
    }],
    activeNames: [],
    hasThird: true
  },
  {
    title: 'Printing LTL/Product Lables',
    children: [{
      title: 'Print with Computer',
      children: [{
        title: 'Print via Bluetooth',
        url: '',
      }, {
        title: 'Print via USB',
        url: '',
      }]
    }, {
      title: 'Print with Phone',
      url: '',
    }],
    activeNames: [],
    hasThird: true
  },
];
const pm241BT = [
  {
    title: 'Must Read Before Use',
    activeNames: [],
    url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM241BT/1RequiredViewing.mp4',
    hasThird: false,
    children: [{
      title: 'Required Viewing',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM241BT/1RequiredViewing.mp4',
    }]
  },
  {
    title: 'Shipping Labels/PDF Printing',
    children: [
      {
        title: 'Printing from a Computer',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM241BT/2PrintingfromaComputer.mp4',
      }, 
    {
      title: 'Printing from a mobile device',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM241BT/3Printingfromamobiledevice.mp4',
    }],
    activeNames: [],
    hasThird: true
  },
  {
    title: 'Creating Personalized Labels（Print barcodes, QR codes, text, icons, and other elements.）',
    children: [{
      title: 'Creating Personalized Labels',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM241BT/4CreatingPersonalizedLabels.mp4',
    }, ],
    activeNames: [],
    hasThird: false
  },
   {
    title: 'Printing LTL/Product Lables',
    activeNames: [],
    hasThird: true,
    children: [
      {
        title: 'Print with Computer',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/PM241BT/5PrintwithComputer.mp4',
    }
  ]
  },
];
const pm241H = [
  {
    title: 'Must Read Before Use',
    activeNames: [],
    url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/241H/1-PM-241H-Quick%20Start%20Guide.mp4',
    hasThird: false,
    children: [{
      title: 'Required Viewing',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/241H/1-PM-241H-Quick%20Start%20Guide.mp4',
    }]
  },
  {
    title: 'Shipping Labels/PDF Printing',
    children: [
      {
        title: 'Printing from a Computer',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/241H/2-PM-241H-How%C2%A0to%C2%A0Print%C2%A0Shipping%C2%A0Labels%20and%20PDF%C2%A0%28via%C2%A0Computer%29.mp4',
      }, 
    {
      title: 'Printing from a mobile device',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/241H/3-PM-241H-How%C2%A0to%C2%A0Print%C2%A0Shipping%C2%A0Labels%20and%20PDF%C2%A0%28via%C2%A0Mobile%29.mp4',
    }],
    activeNames: [],
    hasThird: true
  },
  {
    title: 'Creating Personalized Labels（Print barcodes, QR codes, text, icons, and other elements.）',
    children: [{
      title: 'Creating Personalized Labels',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/241H/4-PM-241H-How%C2%A0to%C2%A0create%C2%A0Labels.mp4',
    }, ],
    activeNames: [],
    hasThird: false
  },
   {
    title: 'Printing LTL/Product Lables',
    activeNames: [],
    hasThird: true,
    children: [
      {
        title: 'Print with Computer',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/241H/5-PM-241H-How%20to%20create%20LTL%20or%20Product%20Labels.mp4',
    }
  ]
  },
];
const S501 = [
  {
    title: 'How to Make Vinyl Labels？',
    activeNames: [],
    hasThird: false,
    children: [
      {
        title: 'Connect via Computer',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S501/%E5%88%B6%E4%BD%9C%E4%B9%99%E7%83%AF%E5%9F%BA%E6%A0%87%E7%AD%BE-%E9%80%9A%E8%BF%87%E7%94%B5%E8%84%91.mp4',
      },
      {
        title: 'Connect via Phone',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S501/%E5%88%B6%E4%BD%9C%E4%B9%99%E7%83%AF%E5%9F%BA%E6%A0%87%E7%AD%BE-%E9%80%9A%E8%BF%87%E6%89%8B%E6%9C%BA.mp4',
      },
    ]
  },
  {
    title: 'How to Use Smart Adhesive Vinyl？',
    children: [
      {
        title: 'Connect via Computer',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S501/%E5%88%B6%E4%BD%9C%E6%99%BA%E8%83%BD%E8%80%97%E6%9D%90-%E9%80%9A%E8%BF%87%E7%94%B5%E8%84%91.mp4',
      },
      {
        title: 'Connect via Phone',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S501/%E5%88%B6%E4%BD%9C%E6%99%BA%E8%83%BD%E8%80%97%E6%9D%90-%E9%80%9A%E8%BF%87%E6%89%8B%E6%9C%BA.mp4',
      },
    ]
  },
  {
    title: 'How to Make Heat Transfer Vinyl (HTV) Labels？',
    children: [
      {
        title: 'Connect via Computer',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S501/%E5%88%B6%E4%BD%9C%E7%86%A8%E7%83%AB%E6%A0%87%E7%AD%BE-%E9%80%9A%E8%BF%87%E7%94%B5%E8%84%91.mp4',
      },
      {
        title: 'Connect via Phone',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S501/%E5%88%B6%E4%BD%9C%E7%86%A8%E7%83%AB%E6%A0%87%E7%AD%BE-%E9%80%9A%E8%BF%87%E6%89%8B%E6%9C%BA.mp4',
      },
    ]
  },
  {
    title: 'How to Make Greeting Cards？',
    children: [
      {
        title: 'Connect via Computer',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S501/%E5%88%B6%E4%BD%9C%E8%B4%BA%E5%8D%A1-%E9%80%9A%E8%BF%87%E7%94%B5%E8%84%91.mp4',
      },
      {
        title: 'Connect via Phone',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S501/%E5%88%B6%E4%BD%9C%E8%B4%BA%E5%8D%A1-%E9%80%9A%E8%BF%87%E6%89%8B%E6%9C%BA.mp4',
      },
    ]
  },
  {
    title: 'How to Make Paper Crafts？',
    children: [
      {
        title: 'Connect via Computer',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S501/%E5%88%B6%E4%BD%9C%E6%8A%98%E7%BA%B8-%E9%80%9A%E8%BF%87%E7%94%B5%E8%84%91.mp4',
      },
      {
        title: 'Connect via Phone',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S501/%E5%88%B6%E4%BD%9C%E6%8A%98%E7%BA%B8-%E9%80%9A%E8%BF%87%E6%89%8B%E6%9C%BA.mp4',
      },
    ]
  },
];
const S41 = [
  {
    title: 'How to Make Vinyl Labels？',
    activeNames: [],
    hasThird: false,
    children: [
      {
        title: 'Connect via Computer',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S41/%E4%B9%99%E7%83%AF%E5%9F%BA%E7%94%B5%E8%84%91.mp4',
      },
      {
        title: 'Connect via Phone',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S41/%E4%B9%99%E7%83%AF%E5%9F%BA%E6%89%8B%E6%9C%BA1.mp4',
      },
      // {
      //   title: 'Connect via Phone',
      //   url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S41/S41-Vinyl%20Labels-phone.mp4',
      // },
    ]
  },
  {
    title: 'How to Use Smart Adhesive Vinyl？',
    children: [
      {
        title: 'Connect via Computer',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S41/%E6%99%BA%E8%83%BD%E8%80%97%E6%9D%90%E7%94%B5%E8%84%91.mp4',
      },
      {
        title: 'Connect via Phone',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S41/%E6%99%BA%E8%83%BD%E8%80%97%E6%9D%90%E6%89%8B%E6%9C%BA.mp4',
      },
    ]
  },
  {
    title: 'How to Make Heat Transfer Vinyl (HTV) Labels？',
    children: [
      {
        title: 'Connect via Computer',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S41/%E7%86%A8%E7%83%AB%E7%94%B5%E8%84%91.mp4',
      },
      {
        title: 'Connect via Phone',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S41/%E7%86%A8%E7%83%AB%E6%89%8B%E6%9C%BA.mp4',
      },
    ]
  },
  {
    title: 'How to Make Paper Crafts？',
    children: [
      {
        title: 'Connect via Computer',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S41/%E6%8A%98%E7%BA%B8%E7%94%B5%E8%84%91.mp4',
      },
      {
        title: 'Connect via Phone',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S41/%E6%8A%98%E7%BA%B8%E6%89%8B%E6%9C%BA.mp4',
      },
    ]
  },
  {
    title: 'How to make foil transfer labels?',
    children: [
      {
        title: 'Connect via Computer',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S41/%E7%AE%94%E8%BD%AC%E5%8D%B0%E7%94%B5%E8%84%91.mp4',
      },
      {
        title: 'Connect via Phone',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S41/%E7%AE%94%E8%BD%AC%E5%8D%B0%E6%89%8B%E6%9C%BA.mp4',
      },
    ]
  },
  {
    title: ' How to print and cut them（Stickers）?',
    children: [
      {
        title: 'Connect via Computer',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S41/%E6%89%93%E5%8D%B0%E5%90%8E%E5%88%87%E5%89%B2-%E7%94%B5%E8%84%91.mp4',
      },
      {
        title: 'Connect via Phone',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/S41/%E6%89%93%E5%8D%B0%E5%90%8E%E5%88%87%E5%89%B2-%E6%89%8B%E6%9C%BA.mp4',
      },
    ]
  },
]
const D422S = [
  {
    title: 'Must Read Before Use(Setup & Paper Loading& Weigh)',
    activeNames: [],
    hasThird: false,
    children: [{
      title: 'Required Viewing',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/D422S/1-Quick%20Start%20Guide.mp4',
    }]
  },
  {
    title: 'How to send Shipping order by D422S & ShipCheer(Cost Assistant)',
    children: [
      {
        title: 'Via Mobile',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/D422S/2-How%20to%20send%20Shipping%20order%20by%20D422S%20%26%20ShipCheer%28Cost%20Assistant%29-mobile.mp4',
      },
      {
        title: 'Via Computer',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/D422S/3-How%20to%20send%20Shipping%20order%20by%20D422S%20%26%20ShipCheer%28Cost%20Assistant%29-computer.mp4',
      },
    ]
  },
  {
    title: 'How to Upload Templates to the Printer',
    children: [
      {
        title: 'Via Mobile',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/D422S/4-How%20to%20Upload%20Templates%20to%20the%20Printer-mobile.mp4',
      },
      {
        title: 'Via Computer',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/D422S/5-How%20to%20Upload%20Templates%20to%20the%20Printer-computer.mp4',
      },
    ]
  },
  {
    title: 'PDF Printing',
    children: [
      {
        title: 'Via Mobile',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/D422S/6-PDF-Printing-mobile.mp4',
      },
      {
        title: 'Via Computer',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/D422S/7-PDF%20Printing-computer.mp4',
      },
    ]
  },
  {
    title: 'Creating Personalized Labels（Print barcodes, QR codes, text, icons, and other elements.）',
    children: [
      {
        title: 'via Computer or Mobile',
        url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/D422S/8-Creating%20Personalized%20Labels.mp4',
      },
    ]
  },
];
const SCREEN = [
  {
    title: 'Upload Templates to Printer via Phone',
    activeNames: [],
    hasThird: false,
    children: [{
      title: 'Required Viewing',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/SCREEN/%E6%A8%A1%E6%9D%BF%E4%BC%A0%E8%BE%93-%E6%89%8B%E6%9C%BA%E7%AB%AF.mp4',
    }]
  },
  {
    title: 'Upload Templates to Printer via Computer',
    activeNames: [],
    hasThird: false,
    children: [{
      title: 'Required Viewing',
      url: 'https://oss.qu-in.top/printerFiles/labelifeFiles/SCREEN/%E6%A8%A1%E6%9D%BF%E4%BC%A0%E8%BE%93-%E7%94%B5%E8%84%91%E7%AB%AF.mp4',
    }]
  },
];
const productInfos = [
  {
    productName: 'PM-2410-BT',
    infoArr: pm2410,
    qrCodeUrl: 'https://qr.labelife.net/?mo=PM-2410-BT',
  }, {
    productName: 'PM-2411-BT',
    infoArr: pm2411,
    qrCodeUrl: 'https://qr.labelife.net/?mo=PM-2411-BT',
  }, {
    productName: 'D520',
    infoArr: d520,
    qrCodeUrl: 'https://qr.labelife.net/?mo=D520BT',
  }, {
    productName: 'D450',
    infoArr: d450,
    qrCodeUrl: '',
  }, {
    productName: 'PM-344-WF',
    infoArr: PM344WF,
    qrCodeUrl: 'https://qr.labelife.net/?mo=PM-344-WF',
  }, {
    productName: 'AM-243-BT',
    infoArr: AM243BT,
    qrCodeUrl: 'https://qr.labelife.net/?mo=AM-243-BT',
  },
  {
    productName: '241-BT',
    infoArr: pm241BT,
    qrCodeUrl: 'https://qr.labelife.net/?mo=PM-241-BT&mac=XXXX&SN=XXXXX',
  },
  {
    productName: 'S501',
    infoArr: S501,
    qrCodeUrl: 'https://support.likcut.com/#/product?pl=likcut&lang=en-us&mo=S501',
  },
  {
    productName: 'S41',
    infoArr: S41,
    qrCodeUrl: 'https://support.likcut.com/#/product?pl=likcut&lang=en-us&mo=S41',
  },
  {
    productName: 'D422S',
    infoArr: D422S,
    qrCodeUrl: 'https://qr.labelife.net/?mo=D422S&mac=XXXX&SN=XXXXX',
  },
  {
    productName: '241H',
    infoArr: pm241H,
    qrCodeUrl: 'https://qr.labelife.net/?mo=PM-241H&mac=XXXX&SN=XXXXX',
  },
  {
    productName: 'SCREEN',
    infoArr: SCREEN,
    qrCodeUrl: '',
  },
];
export { getAllParams, productInfos };



// WEBPACK FOOTER //
// ./src/view/guides/dataConfig.js